import PageHeader from "@/components/PageHeader";
import TheFive from "@/sections/TheFive";
import Why from "@/sections/Why";

export default function TheFivePage() {
  return (
    <>
      <PageHeader silk={1}
        testid="the-five-header"
        eyebrow="The Five"
        titleLines={["Sonsuz katalog değil,", "özenli bir seçki."]}
        lede="The Five, senin için seçilmiş beş kişiden oluşur. Tercihlerin, ilişkiye bakışın ve aradığın uyum bu seçimin bir parçasıdır. Çünkü mesele daha fazla insanla tanışmak değil; içlerinden biriyle gerçekten bir şey başlayabilmesi."
      />
      <TheFive showLink={false} />
      <Why />
    </>
  );
}
